import { openDB } from 'idb'

const DB_NAME = 'medi-db'
const STORE_NAME = 'images'

const dbPromise = openDB(DB_NAME, 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains(STORE_NAME)) {
      db.createObjectStore(STORE_NAME)
    }
  },
})

export async function saveImageToDB(key, base64) {
  const db = await dbPromise
  await db.put(STORE_NAME, base64, key)
}

export async function getImageFromDB(key){
  const db = await dbPromise
  return db.get(STORE_NAME, key)
}

export async function deleteImageFromDB(key) {
  const db = await dbPromise
  await db.delete(STORE_NAME, key)
}
